/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Panel, PanelBody, PanelHeader } from '../../../util/panel';
import { Button, Select, Table, Typography, DatePicker, Input } from 'antd';
import usePaginationHook from '../../../../utils/usePagination';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { FiArrowLeft } from 'react-icons/fi';
import { FaDownload } from 'react-icons/fa';
import { AlertError } from '../../../util/Alert';
import fitSurvey2Services from '../../../../services/fit-survey2.services';
import { Controller, useForm } from 'react-hook-form';

const { RangePicker } = DatePicker;

dayjs.locale('th');

const pageSize = 10;

const LegacySurvey2AnswerText = () => {
  const {
    data: legacySurveyQuestionAnswerTextLists,
    setData,
    page,
    setPage,
    total,
    setTotal,
  } = usePaginationHook();
  const history = useHistory();
  const params = useParams();
  const [loading2, setLoading2] = useState(false);

  const { mutate: downloadLegacyUserAnswerTextsExcel } =
    fitSurvey2Services.useMutationDownloadLegacyUserAnswerTextsExcel(() => {
      setTimeout(() => {
        setLoading2(false);
      }, 600);
    });

  const onDownloadExcelError = (setLoading) => () => {
    setLoading(false);
    AlertError({
      title: 'ดาวน์โหลดไม่สำเร็จ',
      text: 'กรุณาลองใหม่อีกครั้ง',
    });
  };

  const { watch, control, setValue } = useForm({
    memberType: null,
    searchText: '',
    startDate: null,
    endDate: null,
  });

  fitSurvey2Services.useQueryGetLegacySurveyUserAnswerTexts(
    {
      take: pageSize,
      page,
      questionId: params.questionId,
      memberType: watch('memberType'),
      searchText: watch('searchText'),
      startDate: watch('startDate'),
      endDate: watch('endDate'),
    },
    (data) => {
      setData(data.data);
      setTotal(data.meta.total);
    },
  );

  const columns = [
    {
      title: 'NO',
      dataIndex: 'index',
      key: 'index',
      render: (_, record, index) => (
        <span>{(page - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      title: 'วันที่',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (_, record) => (
        <span>{dayjs(record.createdAt).format('DD MMM YYYY HH:mm')}</span>
      ),
      sorter: (a, b) =>
        dayjs(a.createdAt).diff(dayjs(b.createdAt), 'D') > 0 ? 1 : -1,
    },
    {
      title: 'ทีมงาน',
      dataIndex: 'TeamName',
      key: 'TeamName',
      render: (_, record) => <span>{record.user.TeamName}</span>,
    },
    {
      title: 'Honor pin',
      dataIndex: 'HonorCode',
      key: 'HonorCode',
      render: (_, record) => <span>{record.user.HonorCode}</span>,
    },
    {
      title: 'รหัสสมาชิก',
      dataIndex: 'memberCode',
      key: 'memberCode',
      render: (_, record) => <span>{record.memberCode}</span>,
    },
    {
      title: 'ชื่อ',
      dataIndex: 'title',
      key: 'title',
      render: (_, record) => (
        <span>
          {record?.user
            ? `${record?.user?.FirstNameTh ? record?.user?.FirstNameTh : ''} ${
                record?.user?.SurNameTh ? record?.user?.SurNameTh : ''
              }`
            : ''}
        </span>
      ),
    },
    {
      title: '',
      dataIndex: 'isPartner',
      key: 'isPartner',
      render: (_, record) => (
        <span>
          {record.memberType === 'NewMember'
            ? 'คนใหม่'
            : record.isPartner
              ? 'รหัสร่วม'
              : 'รหัสหลัก'}
        </span>
      ),
    },
    {
      title: 'ความคิดเห็น',
      dataIndex: 'answer',
      key: 'answer',
      render: (_, record) => <span>{record.answer}</span>,
      width: 300,
    },
  ];

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <h3
          onClick={() => {
            history.goBack();
          }}
          className="mr-2"
          style={{ cursor: 'pointer' }}
        >
          <FiArrowLeft />
        </h3>
      </div>
      <Panel>
        <PanelHeader>คำตอบ</PanelHeader>
        <PanelBody>
          <div>
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
              }}
              className="mb-2"
            >
              <div className="mr-2" style={{ flex: 1 }}>
                <Typography.Text>
                  รหัสนักธุรกิจ หรือชื่อ-สกุลนักธุรกิจ
                </Typography.Text>
                <Controller
                  name="searchText"
                  control={control}
                  render={({ field: { onChange, value } }) => {
                    return (
                      <Input
                        value={value}
                        onChange={onChange}
                        placeholder="ค้นหาด้วยรหัสนักธุรกิจ หรือชื่อ-สกุลนักธุรกิจ"
                        className="mr-2"
                      />
                    );
                  }}
                />
              </div>
              <div className="mr-2" style={{ flex: 1 }}>
                <Typography.Text>ประเภทนักธุรกิจ</Typography.Text>
                <Controller
                  name="memberType"
                  control={control}
                  render={({ field: { onChange, value } }) => {
                    return (
                      <Select
                        value={value}
                        style={{ width: '100%' }}
                        onChange={onChange}
                      >
                        {[
                          {
                            name: 'ทั้งหมด',
                            value: null,
                          },
                          {
                            name: 'นักธุรกิจเลกาซี',
                            value: 'Distributor',
                          },
                          {
                            name: 'VIP Member',
                            value: 'Member',
                          },
                          {
                            name: 'คนใหม่',
                            value: 'NewMember',
                          },
                        ].map((item) => {
                          return (
                            <Select.Option key={item.value} value={item.value}>
                              {item.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    );
                  }}
                />
              </div>
              <div className="mr-2" style={{ flex: 1 }}>
                <RangePicker
                  placeholder={['วันที่เริ่มต้น', 'วันที่สิ้นสุด']}
                  separator="-"
                  showTime={{ format: 'HH:mm' }}
                  format="YYYY-MM-DD HH:mm"
                  style={{ width: '100%' }}
                  onChange={(value, dateString) => {
                    setValue('startDate', dateString[0]);
                    setValue('endDate', dateString[1]);
                  }}
                />
              </div>
              <Button
                onClick={() => {
                  setLoading2(true);
                  downloadLegacyUserAnswerTextsExcel(
                    {
                      take: -1,
                      page: 1,
                      questionId: params.questionId,
                      memberType: watch('memberType'),
                      searchText: watch('searchText'),
                      startDate: watch('startDate'),
                      endDate: watch('endDate'),
                    },
                    { onError: onDownloadExcelError(setLoading2) },
                  );
                }}
                loading={loading2}
                type="primary"
              >
                <FaDownload className="mr-2" />
                โหลด excel
              </Button>
            </div>
            <Table
              columns={columns}
              dataSource={legacySurveyQuestionAnswerTextLists}
              style={{ backgroundColor: '#fff' }}
              rowKey="id"
              scroll={{ x: 'max-content' }}
              onChange={({ current }) => {
                setPage(current);
              }}
              pagination={{
                pageSize,
                total,
              }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {},
                };
              }}
            />
          </div>
        </PanelBody>
      </Panel>
    </>
  );
};

export default LegacySurvey2AnswerText;
